import { PDFDocument, PDFPage } from "pdf-lib"
import { pageHeight, pageWidth } from "@services/pdf/constants"
import { aspectFillSize, aspectFitSize, drawImageInTopRect, drawWhiteBackground, embedImage } from "./shared"

/**
 * Port of iOS WorkPDFGenerator.drawImagePage — full-page image,
 * aspect-fit (centered with margins) or aspect-fill (bleeds, clipped by page).
 */
export async function drawImagePage(
	doc: PDFDocument,
	page: PDFPage,
	imageJpeg: Uint8Array,
	fill: boolean
): Promise<void> {
	drawWhiteBackground(page)

	const image = await embedImage(doc, imageJpeg)
	const area = { width: pageWidth, height: pageHeight }
	const scaled = fill
		? aspectFillSize({ width: image.width, height: image.height }, area)
		: aspectFitSize({ width: image.width, height: image.height }, area)

	const x = (area.width - scaled.width) / 2
	const yTop = (area.height - scaled.height) / 2
	drawImageInTopRect(page, image, x, yTop, scaled.width, scaled.height)
}
